import { createContext, useEffect, useState } from "react"
import useSWR from 'swr';
import { useAuth0 } from '@auth0/auth0-react'

export interface FarmContextProps {
  children?: React.ReactNode
}

export const FarmContext = createContext<{farms: any[], farm: any, setFarm: (farm: any) => void, isLoading: boolean, accessStartDate: string | null}>({
  farms: [],
  farm: undefined,
  setFarm: () => {},
  isLoading: true,
  accessStartDate: null,
})

function FarmProvider({ children }: FarmContextProps) {
  const { isAuthenticated, isLoading: authLoading } = useAuth0()
  
  // Only fetch farms when authenticated to prevent unnecessary API calls
  const { data: farms, isLoading: farmsLoading } = useSWR(
    isAuthenticated && !authLoading ? '/farms' : null
  )
  
  // Fetch access start date for users
  const { data: accessDateData } = useSWR(
    isAuthenticated && !authLoading ? '/farms/access-date' : null
  )

  const [farm, setFarm] = useState<any>()
  const accessStartDate = accessDateData?.accessStartDate || null

  useEffect(() => {
    if (!farmsLoading && farms?.length > 0) {
      setFarm(farms[0])
    }
  }, [farms, farmsLoading])

  const isLoading = authLoading || farmsLoading

  return (
    <FarmContext.Provider value={{farms: farms || [], farm, setFarm, isLoading, accessStartDate}}>
      {children}
    </FarmContext.Provider>
  )
}

export default FarmProvider
